import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../context/ModalContext';
import { TableRefreshContext } from '../../context/TableRefreshContext';
import {
  IUpdatePackageStatusRequest,
  IUpdatePackageStatusResponse,
} from '../../models/home/updatPackageStatus.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import useHttps from '../useHttps';

const useUpdatePackageStatus = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [resetInputFields, setResetInputFields] = useState(false);
  const modalContext = useContext(ModalContext);
  const refreshTableContext = useContext(TableRefreshContext);

  const onUpdatePackageStatusError = (err: AxiosError<ErrorHttpResponse>) => {
    modalContext?.displayModal(true);
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while updating package status'
    );
  };

  const onUpdatePackageStatusSuccess = ({
    message,
  }: SuccessHttpResponse<IUpdatePackageStatusResponse>) => {
    setResetInputFields(true);
    modalContext?.displayModal(false);
    refreshTableContext?.setRefreshTable(!refreshTableContext?.refreshTable);
    toast.success(message);
  };

  const updatePackageStatus = (data: IUpdatePackageStatusRequest) => {
    const url: HttpConfig = {
      url: `general-service/v1/cargos/${data.cargoId}/package/${data.cargoId}`,
      method: 'put',
      data,
    };

    request(
      url,
      onUpdatePackageStatusSuccess,
      setLoading,
      onUpdatePackageStatusError
    );
  };

  return { updatePackageStatus, loading, resetInputFields };
};

export default useUpdatePackageStatus;
